module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.imageData.length > 0) ? _c('div', {
    staticClass: "image-preview"
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": _vm.imageData
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.imageData.length == 0) ? _c('div', {
    staticClass: "image-preview"
  }, [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": _vm.imageRoot + _vm.preview
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "file-upload-form"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "accept": _vm.accept
    },
    on: {
      "change": _vm.selectedFile
    }
  }), _vm._v("\n    " + _vm._s(_vm.accept.replace(/image\//g, '')) + "のみアップロード可能"), _c('br'), _vm._v("\n    サイズは 幅" + _vm._s(_vm.width) + "px * 高さ" + _vm._s(_vm.height) + "px\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.upload
    }
  }, [_vm._v("アップロード")])]), _vm._v(" "), (_vm.imageMessage) ? _c('div', [_vm._v("\n    " + _vm._s(_vm.imageMessage) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a8aa1c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/ImagePreview.vue
// module id = 452
// module chunks = 1